import { useNavigate } from 'react-router-dom';
import { StatusModal } from '../../components/Modal/Payment';

const FailedPromocode = () => {
  const navigate = useNavigate();

  return (
    <div className='main_page'>
      <StatusModal
        title='Premium Code Invalid'
        subtitle='Oops! Something went wrong.'
        description='The premium code you entered seems to be invalid or has already been used. Please check the code and try again.'
        icon='icon-paper-fail'
        iconColor='var(--red-600)'
        buttonText='Ok'
        onSubmit={() => navigate('/')}
      />
    </div>
  );
};

export default FailedPromocode;
